(function () {
    'use strict';

    angular.module('swif.reservations')
    .service('swifOpenresaService', swifOpenresaService);

    function swifOpenresaService(openresaRequestService, openresaBookingService, openresaRecurrenceService, openresaBookableService, openresaRightsService, openresaPlanningService) {
        'ngInject';
    	var service = {};
        service.requests = openresaRequestService;
        service.bookings = openresaBookingService;
        service.recurrences = openresaRecurrenceService;
        service.bookables = openresaBookableService;
        service.rights = openresaRightsService;
        service.planning = openresaPlanningService;
    	return service;
    }

})();
